<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        :text= "this.$t('qualitycontrol')"
        icon="flag"
        color="bg-pastel-red"
      />
       {{$t('qcdescription1')}}<br/>
       {{$t('qcdescription2')}}<br/>
       {{$t('qcdescription3')}}
      
    </l-container>
    
    <input class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" id="search_field" type="search" placeholder="Search">

    <hot-table id="hothot" :data="sensors" :settings="settings" ref="qchot" :key="componentKey">
      <hot-column :title="this.$t('provider')" data="provider.name" read-only="true"></hot-column>
      <hot-column title="ID" data="id" read-only="true"></hot-column>
      <hot-column :title="this.$t('name')" data="name" read-only="true"></hot-column>
      <hot-column :title="this.$t('description')" data="description" read-only="true"></hot-column>
      <hot-column :title="this.$t('lastprocessed')" :renderer="dateRenderer"  data="pipeline.processed" read-only="true"></hot-column>
      <hot-column :title="this.$t('status')" data="pipeline.status" read-only="true"></hot-column>
      <hot-column :title="this.$t('lastdatareg')" data="lastobservationdate" read-only="true"></hot-column>
    </hot-table>
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import SensorsService from "@/helpers/apiservices/sensors/sensors.service";
import ObservationsService from "@/helpers/apiservices/observations/observations.service";
import { LButton } from "@/components/forms";
import Notify from "@/helpers/notify";
import router from "../../router";
import * as moment from "moment";

const LASTDATA_COLUMN = 6;
const ID_COLUMN = 1;

var qchottable;

export default {
  name: "qcsensors",
  components: {
    HotTable,
    HotColumn,
    LButton 
  },
  data() {
    return {
      sensors: [],
      lastobservations: [],
      settings: HandsontableHelper.settings(false),
      dateRenderer: HandsontableHelper.dateRenderer,
      qclastregdaterenderer: HandsontableHelper.qclastregdaterenderer,
      componentKey: 0,
      refs: this.$refs
    };
  },
  mounted() {
    qchottable = this.$refs.qchot.hotInstance;
    this.settings.afterSelectionEnd = this.selectRowOnly;
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    this.settings.outsideClickDeselects = false;
    this.settings.columnSorting.initialConfig.column = 1;
    //this.settings.columnSorting = false;

    //Testing without using Notify
    //Notify.loadData(null, this.loadInitialData);
    this.loadInitialData();
    
    //Register custom renderer for this table
    Handsontable.renderers.registerRenderer('qcLastRegDateRenderer', this.qcLastRegDateRenderer);

    this.adjustTable();
    //forcing recreation of hot-table since nor re-rendering of table or edit settings updated headers
    this.$root.$on('rendertable', () => {
      //this.componentKey += 1; //This causes problems with the custom rendereres added programatically
    }); 

    //search fields listenere
    const searchField = document.querySelector('#search_field');
    searchField.addEventListener('keyup', function(event) {
      const search = qchottable.getPlugin('search');
      const queryResult = search.query(event.target.value);
      qchottable.render();
    });

  },
  methods: {
    async loadInitialData() {
      this.sensors = await SensorsService.sensors();
      this.getLastObservationsDate();
    },
    async getLastObservationsDate(){
      let obs = await ObservationsService.observationsasync();
      this.sensors.forEach(s => {
        let obj = obs.find( o => o.id === s.id);
        if(obj){
          s.lastobservationdate = obj.timestamp_from_epoch;  
        }
      });
    },
    adjustTable(){
      
      this.$refs.qchot.hotInstance.view.wt.update('onCellDblClick', this.onDoubleClick);

      qchottable.updateSettings({
        cells: function(row, col) {
          var cellProperties = {};

          var mpcelldata = qchottable.getDataAtCell(qchottable.toVisualRow(row), 4);
          var mrcelldata = qchottable.getDataAtCell(qchottable.toVisualRow(row), 6)

          if(mpcelldata){ 
            var mp = moment(mpcelldata);
            if(mp.isBefore(moment(), 'day')){
              cellProperties.className = 'oldData';
            }
            if(mrcelldata){  
              var mr = moment.unix(mrcelldata);
              if(mp && mr && mr.isBefore(moment(mp), 'day')){
                    cellProperties.className = 'posNaNValues';
              }
            }
          }

          if (col === LASTDATA_COLUMN) {
            cellProperties.renderer = "qcLastRegDateRenderer"; 
          }
          return cellProperties;
        },
      });
    },
    onDoubleClick(event, h){
      var plotsensors = [];
      plotsensors.push(this.getSensor(this.$refs.qchot.hotInstance.getDataAtRow([h.row])[ID_COLUMN]));
      router.push({
          name: 'ObservationsPlot',
          params: {
              sensors: plotsensors
          }
      });
    },
    getSensor(id){
      return this.sensors.find(s => s.id == id);
    },
    qcLastRegDateRenderer(instance, td, row, col, prop, value, cellProperties) {
      Handsontable.renderers.TextRenderer.apply(this, arguments);
      td.innerHTML = value && value > 0 ? moment.unix(value).utc().format('YYYY-MM-DD HH:mm') : "" //handling no epoch
    }
  }
};

</script>


<style>
.handsontable .posNaNValues
{
  background-color: orange;
  font-weight: bold;
}
.handsontable .oldData
{
  background-color: palevioletred;
  font-weight: bold;
}
</style>
